export const PlaneIcon = (ps: React.SVGAttributes<SVGElement>) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...ps}>
    <g clipPath="url(#clip0_1_1760)">
      <path
        d="M2.5125 26.25L28.75 15L2.5125 3.75L2.5 12.5L21.25 15L2.5 17.5L2.5125 26.25Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_1760">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
